import { createEventRoute } from 'utils/routes'
import ChatRoulette from './ChatRoulette'

export default {
    chatRoulette: createEventRoute<{ meetingSlug: string }>({
        title: 'ChatRoulette',
        breadcrumb: 'ChatRoulette',
        hasSpaceBreadcrumb: true,
        path: '/chat_roulette/:chatRouletteSlug',
        component: ChatRoulette,
        exact: true,
        context: 'chat-roulette-space'
    }),
}
